<template>
  <div class="warn-band" dir="rtl" role="status" aria-live="polite">
    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    <span class="txt"><slot>{{ text }}</slot></span>
  </div>
</template>

<script>
// Shared amber band (UI_SPEC C4.1). Used for the mode-mismatch caution and for
// the missing-file warning. `role="status"` on purpose — never `role="alert"`:
// neither band blocks anything, and an alert would interrupt the screen reader
// while the recruiter is typing.
export default {
  name: 'CvWarnBand',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.warn-band {
  direction: rtl;
  text-align: right;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-right-width: 4px;
  border-radius: 4px;
  padding: 8px 10px;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.5;
  color: #856404;
}
/* Server-built strings are isolated with CSS, never with a literal <bdi>. */
.warn-band > .txt {
  unicode-bidi: plaintext;
}
.warn-band i {
  font-size: 12px;
  color: #856404;
  margin-left: 6px;
  vertical-align: 1px;
}
</style>
